import { makeStyles } from '@fluentui/react-components';

export const useAppLayoutStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    fontFamily: 'Segoe UI, sans-serif',
  },
  header: {
    height: '48px',
    padding: '16px 24px',
    backgroundColor: 'var(--colorBrandBackground)',
    color: 'var(--colorNeutralForegroundOnBrand)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  headerIcon: {
    color: 'var(--colorNeutralForegroundOnBrand)',
    fontSize: '20px',
  },
  headerTitle: {
    color: 'var(--colorNeutralForegroundOnBrand)',
    fontSize: '14px',
  },
  headerUserName: {
    color: 'var(--colorNeutralForegroundOnBrand)',
  },
  headerUserButton: {
    color: 'var(--colorNeutralForegroundOnBrand)',
    gap: '8px',
    ':hover': {
      color: 'var(--colorNeutralForegroundOnBrand)',
      backgroundColor: 'var(--colorBrandBackgroundHover)',
    },
    ':hover:active': {
      color: 'var(--colorNeutralForegroundOnBrand)',
      backgroundColor: 'var(--colorBrandBackgroundPressed)',
    },
  },
  body: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: 'var(--colorNeutralBackground1)',
  },
  contentRoutes: {
    flex: 1,
    padding: '24px',
    overflow: 'auto',
  },
});
